import React, { useEffect, useState } from 'react'
import '../css/order.css';
import Header from '../components/Header'
import Product from '../components/Product'
import ShoppingCart from '../components/ShoppingCart';
import AddCartPopup from '../components/AddCartPopup';
import { useLoaderData } from 'react-router-dom';
import { list } from '../assets/mangoeaList';
import Modal from '../components/Modal';

const Order = () => {
  const [ isOpened, setIsOpened ] = useState(false);
  const [customPopup, setCustomPopup ] = useState(false);
  const [ currentMangoe, setCurrentMangoe ] = useState();
  const [ action, setAction ] = useState("add");

  const [ modalIsOpen, setModalIsOpen ] = useState(false);

  const closeAlertModal = () => {
    setModalIsOpen(false)
  }
  const openAlertModal = () => {
    setModalIsOpen(true)
  }

  let mangoes = useLoaderData();

  const closeModal = () => {
    setIsOpened(false);
  }
  const openModal = () => {
    setIsOpened(true);
  }

  const closeCustomPopup = () => {
    setCustomPopup(false);
    // setModalIsOpen(true);
  }
  const openCustomPopup = (mangoe, action_ = "add") => {
    setCurrentMangoe(mangoe);
    setAction(action_);
    setCustomPopup(true);
  }

  return (
    <>
      {/* CART */}
      {customPopup && <AddCartPopup
        closeModal={closeCustomPopup}
        showAlert={openAlertModal}
        mangoe={currentMangoe}
        action={action}
      />}
      
      {isOpened && <ShoppingCart closeModal={closeModal} openCustomPopup={openCustomPopup} />}

      <Header page="order" openModal={openModal} />

      <main className="order">
        <section>
          {
            mangoes.map(mangoe =>
              <Product
                key={mangoe.mango_id}
                mangoe={mangoe}
                openCustomPopup={openCustomPopup}
              />
            )
          }
        </section>
      </main>

      {
        modalIsOpen && <Modal
          onClose={closeAlertModal}
          title="Commande ajoutée !"
          description="La variété est ajoutée au panier !"
        />
      }
    </>
  )
}

export const dataLoader = async () => {
  const res = await fetch("https://api.sunumango.com/stuff/mangoes");
  const data = await res.json();
  // console.log(data);
  return data;
}

export default Order